// @ts-nocheck

/**
 * * `solid` - solid
 * `dashed` - dashed
 * `dotted` - dotted
 * `none` - none
 */
export type StyleEnum = typeof StyleEnum[keyof typeof StyleEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StyleEnum = {
  solid: "solid",
  dashed: "dashed",
  dotted: "dotted",
  none: "none",
} as const;
